import FormFieldsValidators from "../utils/FormFieldsValidators";
export default {
    data() {
        return {
            formErrors: {},
        };
    },
    computed: {
        hasFormErrors() {
            return Object.keys(this.formErrors).length > 0;
        },
    },
    methods: {
        validateForm(formFields, formData) {
            for (let field of formFields) {
                let fieldErrors = [];
                let fieldValidators = field.validate?.map(element => FormFieldsValidators[element]);
                fieldValidators?.forEach(validator => {
                    let error = validator(formData[field.name]);
                    if (error) {
                        fieldErrors.push(error);
                    }
                });
                fieldErrors.length && this.$set(this.formErrors, field.name, fieldErrors);
            }
            return Object.keys(this.formErrors).length === 0;
        },
        clearFieldErrors(field) {
            this.$delete(this.formErrors, field.name);
        },
    },
};
